/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React from 'react';
import { useState, useEffect } from 'react';

const StatsOverview = ({ stats }) => {
    const [statsData, setStatsData] = useState([
        { label: "Total Patients", key: "patientCount", value: "" },
        { label: "Total Visits", key: "visitCount", value: "" },
        { label: "Total Appointment", key: "appointmentCount", value: "" },
        { label: "Total Report Shared by Patient", key: "reportSharedCount", value: "" },
        { label: "Total Knowledge Shared", key: "KnowledgeCount", value: "" },
        { label: "Total Prescription Shared", key: "prescriptionSharedCount", value: "" },
        { label: "Total Diet Chart Print", key: "patientDietCount", value: "" }
    ])

    useEffect(() => {
        if (stats) {
            const cloneData = statsData
            cloneData.map((ele) => {
                ele.value = stats[ele.key]
            })
            setStatsData([...cloneData])
        }
    }, [stats])

    return (
        <div className="stats-container">
            {statsData.map((stat, index) => (
                <div key={index} className="stats-card d-flex align-items-center justify-content-center flex-column m-0">
                    <div className="stats-header m-0">{stat.label}</div>
                    <div className="stats-value">{stat.value}</div>
                </div>
            ))}
        </div>
    );
};

export default StatsOverview;